import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'daysAgo',
  standalone: true,
})
export class DaysAgoPipe implements PipeTransform {
  translationService = inject(TranslateService);
  transform(value: Date | undefined): string {
    if (!value || value.toString() === '0001-01-01T00:00:00') {
      return this.translationService.instant('never');
    }

    const valueDate = new Date(value);
    const currentDate = new Date();
    const dateValue = new Date(valueDate.getFullYear(), valueDate.getMonth(), valueDate.getDate());
    const timeDifference = currentDate.getTime() - dateValue.getTime();
    const daysAgo = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

    if (daysAgo === 0) {
      return this.translationService.instant('today');
    } else if (daysAgo === 1) {
      return this.translationService.instant('yesterday');
    } else {
      return `${daysAgo} ${this.translationService.instant('days-ago')}`;
    }
  }
}
